(() => {
  const api = 'https://wei-cake-order-api.szhang0426.workers.dev';
  const accessoryHandles = new Set([
    'utensils', 'utensils-5pc', 'birthday-hat', 'birthday-cone-hat',
    'happy-birthday-topper', 'insulated-bag-with-ice-packs', 'candle-1pc', 'candle'
  ]);

  const style = document.createElement('style');
  style.textContent = `
    .cake-cart-locked { display: none !important; }
    .cake-cart-quantity-display { margin:.8rem 0; font-size:1.4rem; }
  `;
  document.head.append(style);

  function lineFromRemoveLink(link) {
    const url = new URL(link.href, window.location.origin);
    const fromUrl = Number(url.searchParams.get('line'));
    const fromButton = Number(link.closest('cart-remove-button')?.dataset?.index);
    return fromUrl || fromButton || 0;
  }

  function lineFromQuantityInput(input) {
    return Number(input.dataset.index || input.closest('[data-index]')?.dataset.index || 0);
  }

  async function releaseReservationForLine(line) {
    const response = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await response.json();
    const id = cart.items?.[line - 1]?.properties?.['Reservation ID'];
    if (!id) return;
    await fetch(`${api}/release`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id }),
      keepalive: true,
    });
  }

  async function lockCartQuantities() {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await response.json();
      document.querySelectorAll('input[name="updates[]"]').forEach((input) => {
        const item = cart.items?.[lineFromQuantityInput(input) - 1];
        if (!item || accessoryHandles.has(item.handle)) return;
        const control = input.closest('quantity-input') || input.closest('.quantity');
        control?.classList.add('cake-cart-locked');
        if (control && !control.parentElement?.querySelector('.cake-cart-quantity-display')) {
          const display = document.createElement('p');
          display.className = 'cake-cart-quantity-display';
          display.textContent = String(item.quantity);
          control.insertAdjacentElement('afterend', display);
        }
      });
    } catch (_) {
      // If Shopify's cart cannot be read, its standard cart controls remain available.
    }
  }

  lockCartQuantities();
  new MutationObserver(() => lockCartQuantities()).observe(document.body, { childList: true, subtree: true });

  // This runs before Craft's normal remove action. It does not run for plus/minus buttons.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('cart-remove-button a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (Number(url.searchParams.get('quantity')) !== 0) return;
    const line = lineFromRemoveLink(link);
    if (line) releaseReservationForLine(line).catch(() => {});
  }, true);
})();
